import { createApp } from 'vue'
import { createHead } from '@vueuse/head';
import App from './App.vue'
import router from './router'
import store from './store'
import Quasar from 'quasar/src/vue-plugin.js';import Loading from 'quasar/src/plugins/loading/Loading.js';import Notify from 'quasar/src/plugins/notify/Notify.js';
import quasarUserOptions from './quasar-user-options'

const head = createHead();

createApp(App).use(Quasar, { plugins: { Loading, Notify } }, quasarUserOptions).use(store).use(router).use(head).mount('#app')
